import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { RirekishoPersonalRequests } from '@src/api/core/api-types';

const initialState: RirekishoPersonalRequests = {
  requests: [],
  additionalNote: '',
};

const rirekishoPersonalRequestsSlice = createSlice({
  name: 'rirekishoPersonalRequests',
  initialState,
  reducers: {
    updateRirekishoPersonalRequests: (
      state,
      action: PayloadAction<Partial<RirekishoPersonalRequests>>
    ) => {
      return { ...state, ...action.payload };
    },
    addRirekishoRequest: (state, action: PayloadAction<string>) => {
      state.requests.push(action.payload);
    },
    removeRirekishoRequest: (state, action: PayloadAction<number>) => {
      state.requests.splice(action.payload, 1);
    },
    updateRirekishoRequest: (state, action: PayloadAction<{ index: number; value: string }>) => {
      const { index, value } = action.payload;
      if (state.requests[index] !== undefined) {
        state.requests[index] = value;
      }
    },
    resetRirekishoPersonalRequests: () => initialState,
  },
});

export const {
  updateRirekishoPersonalRequests,
  addRirekishoRequest,
  removeRirekishoRequest,
  updateRirekishoRequest,
} = rirekishoPersonalRequestsSlice.actions;

export default rirekishoPersonalRequestsSlice.reducer;
